var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Editor as TyneMCE } from '@tinymce/tinymce-react';
import { getImageInfo, loadImageFromS3, uploadFile, getFileFromImg, getFileFromInput } from '../../../helpers/fileFunctions';
import './Editor.scss';
const key = '91aa175iydmggp8twmfslb3jmodsud6t6iiai29p7ky3c1ek';
// eslint-disable-next-line @typescript-eslint/naming-convention
const content_style = 'img { max-width: 100%; height: auto; } p { margin: 0 0 8px 0; } a { color: #DC1C24; } a:hover { color: #69052D; }';
const Editor = (_a) => {
    var { mode = 'edit', noMedia = false, onEditorChange } = _a, rest = __rest(_a, ["mode", "noMedia", "onEditorChange"]);
    function handleOnEditorChange(content, editor) {
        return __awaiter(this, void 0, void 0, function* () {
            // console.log('handleOnEditorChange')
            // console.log('Content', content)
            !!onEditorChange && onEditorChange(content, editor);
        });
    }
    if (mode === 'view') {
        return (React.createElement(TyneMCE, Object.assign({ apiKey: key, init: {
                plugins: 'autoresize',
                // max_height: 300,
                autoresize_min_height: 36,
                // autoresize_max_height: 300,
                autoresize_bottom_margin: 0,
                menubar: false,
                statusbar: false,
                toolbar: false,
                width: '100%',
                content_style: `body { img { max-width: 100%; height: auto; }  margin: 0; padding: 0; } p { body: 0;} ${content_style}`,
                relative_urls: false,
                convert_urls: false,
            }, disabled: true, onEditorChange: handleOnEditorChange }, rest)));
    }
    return (React.createElement(TyneMCE, Object.assign({ apiKey: key, init: {
            branding: false,
            file_picker_types: 'image',
            file_picker_callback: (callback, value, meta) => {
                if (meta.filetype === 'image') {
                    const input = document.createElement('input');
                    input.setAttribute('type', 'file');
                    input.setAttribute('accept', 'image/*');
                    // eslint-disable-next-line func-names
                    input.onchange = function (e) {
                        const file = getFileFromInput(e);
                        console.log(file);
                        const reader = new FileReader();
                        // const readerString: string = reader?.result?.toString() || '';
                        // eslint-disable-next-line func-names
                        reader.onload = function () {
                            var _a;
                            const readerString = ((_a = reader === null || reader === void 0 ? void 0 : reader.result) === null || _a === void 0 ? void 0 : _a.toString()) || '';
                            callback(readerString, { alt: file.name });
                        };
                        // reader.onload = function () {
                        //   /*
                        //   Note: Now we need to register the blob in TinyMCEs image blob
                        //   registry. In the next release this part hopefully won't be
                        //   necessary, as we are looking to handle it internally.
                        //   */
                        //   const id = `blobid${new Date().getTime()}`;
                        //   const { blobCache } = tinymce.activeEditor.editorUpload;
                        //   const base64 = reader.result.split(',')[1];
                        //   const blobInfo = blobCache.create(id, file, base64);
                        //   blobCache.add(blobInfo);
                        //   /* call the callback and populate the Title field with the file name */
                        //   callback(blobInfo.blobUri(), { title: file.name });
                        // };
                        reader.readAsDataURL(file);
                    };
                    input.click();
                }
                else {
                    // eslint-disable-next-line no-alert
                    alert('We only support images for now =(');
                }
            },
            paste_data_images: !noMedia,
            height: 300,
            menubar: false,
            plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount',
            ],
            toolbar: noMedia
                ? `undo redo | styleselect | bold italic underline backcolor forecolor align | numlist bullist | code help`
                : `undo redo | styleselect | bold italic underline backcolor forecolor align | numlist bullist image media | code help`,
            content_style,
            relative_urls: false,
            convert_urls: false,
            style_formats_merge: false,
            formats: {
                title: {
                    selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video',
                    styles: { fontFamily: '"Inter", sans-serif', fontWeight: 'bold', frontSize: '24px', color: '#0a0000', lineHeight: '28px', marginBottom: '24px' },
                    attributes: { title: 'Title' },
                },
                subtitle: {
                    selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video',
                    styles: { fontFamily: '"Inter", sans-serif', fontWeight: 'bold', frontSize: '24px', color: '#0a0000', lineHeight: '22px', marginBottom: '16px' },
                    attributes: { title: 'Subtitle' },
                },
                paragraph: {
                    selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video',
                    styles: { fontFamily: '"Inter", sans-serif', fontWeight: 'normal', frontSize: '24px', color: '#0a0000', lineHeight: '19px', marginBottom: '8px' },
                    attributes: { title: 'Paragraph' },
                },
            },
            style_formats: [
                { title: 'Title', format: 'title' },
                { title: 'Subtitle', format: 'subtitle' },
                { title: 'Paragraph', format: 'paragraph' },
                // {
                //   title: 'Badge',
                //   inline: 'span',
                //   styles: { display: 'inline-block', border: '1px solid #2276d2', 'border-radius': '5px', padding: '2px 5px', margin: '0 2px', color: '#2276d2' },
                // // },
                // { title: 'Table row 1', selector: 'tr', classes: 'tablerow1' },
                // { title: 'Image formats' },
                // { title: 'Image Left', selector: 'img', styles: { float: 'left', margin: '0 10px 0 10px' } },
                // { title: 'Image Right', selector: 'img', styles: { float: 'right', margin: '0 0 10px 10px' } },
            ],
        }, onEditorChange: handleOnEditorChange }, rest)));
};
// eslint-disable-next-line func-names
Editor.treatContentBeforeShow = function (bucket, content) {
    return __awaiter(this, void 0, void 0, function* () {
        // console.log('treatContentBeforeShow')
        // console.log('content', content)
        if (!content)
            return '';
        if (bucket.includes('userimages'))
            return content;
        const wrapper = document.createElement('div');
        wrapper.innerHTML = content;
        const imgs = Array.from(wrapper.querySelectorAll('img'));
        // console.log('wrapper.innerHTML', wrapper.innerHTML)
        // console.log('Images', imgs)
        yield Promise.all(imgs.map((img) => __awaiter(this, void 0, void 0, function* () {
            if (!img.src) {
                return Promise.resolve();
            }
            if (bucket.includes('userimages')) {
                // // eslint-disable-next-line no-param-reassign
                // img.src = `/public/${img.src}`;
                return Promise.resolve();
            }
            // console.log('Loading Image', img)
            const { fileName } = getImageInfo(img);
            return loadImageFromS3(`original/${fileName}`, bucket).then((src) => {
                img.setAttribute('data-key', fileName);
                // eslint-disable-next-line no-param-reassign
                img.src = src;
                // console.log('Image loaded', img)
            });
        })));
        // eslint-disable-next-line no-param-reassign
        content = wrapper.innerHTML;
        return content;
    });
};
Editor.treatContentBeforeSave = function treatContentBeforeSave(content_1, identity_1, bucket_1) {
    return __awaiter(this, arguments, void 0, function* (content, identity, bucket, env = '') {
        // console.log('treatContentBeforeSave')
        const wrapper = document.createElement('div');
        wrapper.innerHTML = content;
        const imgs = Array.from(wrapper.querySelectorAll('img'));
        // console.log('wrapper.innerHTML', wrapper.innerHTML)
        // console.log('Images', imgs)
        yield Promise.all(imgs.map((img) => {
            if (bucket.includes('userimages')) {
                if (!img.src.includes('.trurisk.io/public')) {
                    return getFileFromImg(img).then((file) => 
                    // console.log('file', file)
                    uploadFile(file, { usage_type: 2 }, identity, bucket).then((fileUploaded) => {
                        // eslint-disable-next-line no-param-reassign
                        img.loading = 'lazy';
                        // eslint-disable-next-line no-param-reassign
                        img.src = `https://${env}/public/${fileUploaded.key}`;
                    }));
                }
                return Promise.resolve();
            }
            if (img.src.indexOf('media-assets-target') === -1 && !img.getAttribute('data-key')) {
                // console.log('New Image', img)
                return getFileFromImg(img).then((file) => 
                // console.log('file', file)
                uploadFile(file, { usage_type: 2 }, identity, bucket).then((fileUploaded) => {
                    // eslint-disable-next-line no-param-reassign
                    img.src = fileUploaded.key;
                    // img.src = bucket.includes('userimages') ? `https://test.trurisk.io/public/${fileUploaded.key}` : fileUploaded.key;
                }));
            }
            // console.log('Database/S3 Image', img)
            if (img.getAttribute('data-key')) {
                // eslint-disable-next-line no-param-reassign
                img.src = img.getAttribute('data-key') || '';
            }
            return Promise.resolve();
        }));
        if (imgs.length) {
            // eslint-disable-next-line no-promise-executor-return
            yield new Promise((resolve) => setTimeout(resolve, 1000)); // await images to be processed by the backend
        }
        // eslint-disable-next-line no-param-reassign
        content = wrapper.innerHTML
            // eslint-disable-next-line
            // .replace(/\"/g, '\\"')
            .replace(/\r?\n|\r|\n/g, '');
        // console.log('Content', content)
        return content;
    });
};
export default Editor;
